import { Action, createReducer, on } from '@ngrx/store';
import * as FeatureFlagActions from './feature-flag.actions';

export interface FeatureFlagState {
  dgExerciseServiceDisruptionHyperwallet: boolean;
}

const initialState: FeatureFlagState = {
  dgExerciseServiceDisruptionHyperwallet: false,
};

const reducer = createReducer(
  initialState,
  on(
    FeatureFlagActions.setDgExerciseServiceDisruptionHyperwallet,
    (state, { dgExerciseServiceDisruptionHyperwallet }) => ({
      ...state,
      dgExerciseServiceDisruptionHyperwallet,
    }),
  ),
);

export function featureFlagReducer(
  state: FeatureFlagState | undefined,
  action: Action,
): FeatureFlagState {
  return reducer(state, action);
}
